<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { cloneDeep, groupBy } from "lodash";
import { required } from "vuelidate/lib/validators";
import PrintOptions from "@/components/modals/print-options.vue";
import ItemCategory from "@/components/modals/item-category-with-personnels.vue";
import Unit from "@/components/modals/unit.vue";
import RequestItemCard from "@/router/views/procurement/settings-template/request-item-card.vue";
import ReturnModal from "@/components/modals/return-item-request.vue";
import Swal from "sweetalert2";
import UpdateItemRequest from "@/components/modals/update-item-request.vue";
import ItemLogs from "@/components/modals/item-request-logs.vue";
import ItemListSidebar from './item-list-sb.vue'

export default {
    page: {
        title: "Responsibility Center",
    },
    components: {
        Layout,
        PageHeader,
        PrintOptions,
        ItemCategory,
        Unit,
        RequestItemCard,
        ReturnModal,
        UpdateItemRequest,
        ItemLogs,
        ItemListSidebar
    },
    data() {
        return {
            title: "Responsibility Center [Technical Review]",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Responsibility Center [Technical Review]",
                    active: true,
                },
            ],
            tfr: [],
            tr: [],
            cycles: [],
            tableData: [],
            itemBusy: false,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            sortByTR: "name",
            sortDesc: false,
            trFields: [
                {
                    key: "office",
                    sortable: true,
                },
                {
                    key: "name",
                    sortable: true,
                    label: "Work Name",
                },
                {
                    key: "totalAmt",
                    sortable: true,
                    label: "Total Amount",
                    thStyle: { width: "20%" },
                },
                {
                    key: "status",
                    thStyle: { width: "200px" },
                },
                {
                    key: "action",
                    thStyle: { width: "150px" },
                },
            ],
            indexSelected: -1,
            itemSelected: {},
            form: {
                id: "",
                remarks: "",
            },

            // tfr
            filterTFR: "",
            currentPageTFR: 1,
            filterOnTFR: [],
            totalRowsTFR: 1,
            tfrBusy: false,

            // TR
            filterTR: "",
            currentPageTR: 1,
            filterOnTR: [],
            totalRowsTR: 1,
            trBusy: false,
            itemResource: {
                id: 0,
                itemName: null,
                description: null,
                itemCategoryName: null,
                itemCategoryId: null,
                unitId: null,
                unitName: null,
            },
            selectedItemResource: null,
            selectedParent: null,
            selectedGrandparent: null,
            pendingRequestItems: [],
            approvedRequestItems: [],
            pendingItemBusy: false,
            myProfile: null,
            approvedItemBusy: false,
            sideBar: false,
            itemCats: [],
            pendingReqTotal: 0,
            approvedReqTotal: 0
        };
    },
    validations: {
        form: { remarks: { required } },
        itemResource: {
            itemName: { required },
            description: { required },
            itemCategoryId: { required },
            unitId: { required },
        }
    },
    async created() {
        var cycles = [{ text: "", value: 0 }];
        this.$store
            .dispatch("cycle/GetAllCycle")
            .then((res) => {
                res.data.forEach((item) => {
                    cycles.push({ value: item.year, text: item.year });
                });
                this.cycles = cycles;
            })
            .catch(() => {
                this.showToast('Something went wrong!', 'error');
            });
        this.pendingItemBusy = true;
        await this.getProfile();
        await this.changeParameters(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id)
    },
    computed: {
        ffrRows() {
            return this.tfr.length;
        },
        frRows() {
            return this.tr.length;
        },
    },
    methods: {
        async getItems(cycle, campusId) {
            this.tableData = [];
            this.itemBusy = true;
            this.$store
                .dispatch("item/GetItemByTechRep", {cycle, campusId})
                .then((res) => {
                    this.itemBusy = false;
                    res.data.forEach((item) => {
                        item.cost = this.formatCurrency(item.unitCost);
                        item.filterKey = `${item.itemName} ${item.description}`
                        item.trimmedItemName = item.itemName.replace(/\s/g, "").trim().toLowerCase();
                    });
                    let grp = groupBy(res.data, 'itemCategoryId');
                    let itemCats = [];
                    for(let key in grp){
                        itemCats.push({
                            id: key,
                            itemCategory: grp[key][0].itemCategory
                        })
                    }
                    this.itemCats = itemCats.sort((a, b) => a.itemCategory.localeCompare(b.itemCategory));
                    this.tableData = res.data.sort((a, b) => a.trimmedItemName.localeCompare(b.trimmedItemName));
                })
                .catch((err) => {
                    this.itemBusy = false;
                    this.showToast(
                        "Something went wrong! - getting Item",
                        "error"
                    );
                });
        },
        async getProfile(){
            await this.$store
                .dispatch("account/GetProfile")
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.myProfile = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async changeParameters(cycle, campusId){
            // this.getTFR(cycle, campusId);
            // this.getTR(cycle, campusId);
            this.getItems(cycle, campusId);
            this.pendingItemBusy = true;
            await this.getItemRequests('pending');
            await this.getItemRequests('approved');
            this.pendingItemBusy = false;
        },
        getPercentage(x, y) {
            let percent = (x / y) * 100;
            let decimal = percent.toFixed(2);
            let number = decimal.split(".");
            if (number[1] > 0) {
                return number[0] + "." + number[1];
            }
            return percent;
        },
        async getItemRequests(type){
            if(type == 'pending')
                await this.$store
                    .dispatch("itemrequest/GetTechnicalPendingItemRequest")
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'warning');
                        }
                        var groups = [];
                        var grouped = groupBy(res.data, "deliveryUnitId");
                        var sumAll = 0;
                        for (var key in grouped) {
                            var filterKey = "";
                            grouped[key].map(item => {
                                filterKey += ` ${item.itemName} ${item.description}`
                                item.filterKey = `${item.itemName} ${item.description}`;
                            })
                            groups.push({
                                deliveryUnitId: key,
                                name: grouped[key][0].deliveryUnit,
                                count: grouped[key].length,
                                showDetails: false,
                                items: grouped[key],
                                filterKey: filterKey
                            });
                            sumAll += grouped[key].length;
                        }
                        this.pendingRequestItems = groups;
                        this.pendingReqTotal = sumAll;
                    })
                    .catch((err) => {
                        this.showToast('Something went wrong!', 'error');
                    });
            else{
                this.approvedItemBusy = true;
                await this.$store
                    .dispatch("itemrequest/GetTechnicalApproveItemRequest")
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'warning');
                        }
                        this.approvedItemBusy = false;
                        var groups = [];
                        var sumAll = 0;
                        var grouped = groupBy(res.data, "deliveryUnitId");
                        for (var key in grouped) {
                            var filterKey = "";
                            grouped[key].map(item => {
                                filterKey += ` ${item.itemName} ${item.description}`
                                item.filterKey = `${item.itemName} ${item.description}`;
                            })
                            groups.push({
                                deliveryUnitId: key,
                                name: grouped[key][0].deliveryUnit,
                                count: grouped[key].length,
                                showDetails: false,
                                items: grouped[key],
                                filterKey: filterKey
                            });
                            sumAll += grouped[key].length;
                        }
                        this.approvedRequestItems = groups;
                        this.approvedReqTotal = sumAll;
                    })
                    .catch((err) => {
                        this.approvedItemBusy = false;
                        this.showToast('Something went wrong!', 'error');
                    });
            }
        },
        // tfr
        onFilteredTFR(filteredItems) {
            this.totalRowsTFR = filteredItems.length;
            this.currentPageTFR = 1;
        },
        getTFR(cycle, campusId) {
            this.tfrBusy = true;
            var id = 1;
            this.$store
                .dispatch("responsibilitycenter/GetReviewTechnical", {cycle, campusId})
                .then((res) => {
                    if(res.data.error){
                        this.tfrBusy = false;
                        return this.showToast(res.data.errorMessage, 'warning');
                    }
                    var numberOfTechnicalReview = 0;
                    res.data.forEach((item) => {
                        item.totalAmt = this.formatCurrency(item.totalResources);
                        item.numberOfApproved = 0;
                        item.apiResources.forEach((x) => {
                            if (x.technicalReviewStatus.toUpperCase().includes("APPROVE")) {
                                item.numberOfApproved++;
                            }else if(x.technicalReviewStatus.toUpperCase().includes("PENDING")){
                                numberOfTechnicalReview++;
                            }
                            x.toggleItem = false;
                        });
                        var grouped = groupBy(
                            item.apiResources,
                            "itemCategory.name"
                        );
                        item.groupItems = [];
                        for (const y in grouped) {
                            var totalApproved = 0;
                            grouped[y].forEach((z) => {
                                if (
                                    z.technicalReviewStatus
                                        .toUpperCase()
                                        .includes("APPROVE")
                                ) {
                                    totalApproved++;
                                }
                            });
                            item.groupItems.push({
                                id: id++,
                                name: y,
                                toggleKey: true,
                                data: grouped[y],
                                totalApproved: totalApproved,
                            });
                        }
                    });
                    let dashboardData = JSON.parse(localStorage.getItem("dashboardData"));
                    dashboardData.needTechnicalReview = numberOfTechnicalReview;
                    localStorage.setItem("dashboardData", JSON.stringify(dashboardData));
                    this.attachedDUNotifications();
                    this.tfr = res.data;
                    this.tfrBusy = false;
                })
                .catch((err) => {
                    this.tfrBusy = false;
                    this.showToast('Something went wrong!', 'error');
                });
        },

        // TR
        onFilteredTR(filteredItems) {
            this.totalRowsTFR = filteredItems.length;
            this.currentPageTFR = 1;
        },
        getTR(cycle, campusId) {
            this.$store
                .dispatch("responsibilitycenter/GetReviewedTechnical", {cycle, campusId})
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'warning');
                    }
                    var id = 1;
                    res.data.forEach((item) => {
                        item.totalAmt = this.formatCurrency(item.totalResources);
                        item.numberOfApproved = 0;
                        item.apiResources.forEach((x) => {
                            if (
                                x.technicalReviewStatus
                                    .toUpperCase()
                                    .includes("APPROVE")
                            ) {
                                item.numberOfApproved++;
                            }
                            x.toggleItem = false;
                        });
                        // var grouped = groupBy(
                        //     item.apiResources,
                        //     "itemCategory.name"
                        // );
                        // item.groupItems = [];
                        // for (const y in grouped) {
                        //     var totalApproved = 0;
                        //     grouped[y].forEach((z) => {
                        //         if (z.technicalReviewStatus) {
                        //             totalApproved++;
                        //         }
                        //     });
                        //     item.groupItems.push({
                        //         id: id++,
                        //         name: y,
                        //         toggleKey: false,
                        //         data: grouped[y],
                        //         totalApproved: totalApproved,
                        //     });
                        // }
                    });
                    this.tr = res.data;
                })
                .catch(() => {
                    this.showToast('Something went wrong!', 'error');
                });
        },
        viewItems(row) {
            row.toggleDetails();
        },
        approveItem(x, y, row) {
            var index = this.tfr.indexOf(row);
            this.$store
                .dispatch("responsibilitycenter/ApproveTechnical", x.id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, 'warning');
                    }
                    row.numberOfApproved++;
                    x.technicalReviewStatus = "APPROVED";
                    y.totalApproved++;
                    this.showToast('Successfully approved', 'success');
                    let dashboardData = JSON.parse(localStorage.getItem("dashboardData"));
                    dashboardData.needTechnicalReview = dashboardData.needTechnicalReview - 1;
                    localStorage.setItem("dashboardData", JSON.stringify(dashboardData));
                    this.attachedDUNotifications();
                    setTimeout(() => {
                        if (row.numberOfApproved == row.apiResources.length) {
                            this.tr.push(row);
                            this.tfr.splice(index, 1);
                        }
                    }, 1000);
                })
                .catch(() => {
                    this.showToast('Something went wrong!', 'error');
                });
        },
        returnItem(x) {
            this.itemSelected = x;
            this.form.id = this.itemSelected.id;
            this.form.remarks = "";
            this.$bvModal.show("return-modal");
        },
        returnSubmit() {
            this.$store
                .dispatch("responsibilitycenter/ReturnTechnical", this.form)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, 'warning');
                    }
                    this.itemSelected.technicalReviewStatus = "RETURN";
                    this.$bvModal.hide("return-modal");
                    this.showToast('Successfully returned', 'success');
                    let dashboardData = JSON.parse(localStorage.getItem("dashboardData"));
                    dashboardData.needTechnicalReview = dashboardData.needTechnicalReview - 1;
                    localStorage.setItem("dashboardData", JSON.stringify(dashboardData));
                    this.attachedDUNotifications();
                })
                .catch((err) => {
                    this.showToast('Something went wrong!', 'error');
                });
        },
        hideModal() {
            this.$bvModal.hide("return-modal");
        },
        printPPMP(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/My/PPMP/API",
                routeVariables: [id],
            });
            this.$bvModal.show("print-options-modal");
        },
        updateItemResource(row, parent, grandparent){
            this.selectedItemResource = row;
            this.selectedParent = parent;
            this.selectedGrandparent = grandparent;
            this.itemResource = {
                id: row.id,
                itemName: row.itemName,
                description: row.description,
                itemCategoryId: row.itemCategoryId,
                itemCategoryName: row.itemCategory.name,
                unitId: row.unitId,
                unitName: row.unit.shortName,
            };
            this.$bvModal.show('update-item-modal');
        },
        getItemCategory(type) {
            this.itemCatType = type;
            this.$bvModal.show("item-category-modal");
        },
        dropItemCat(data) {
            if(this.itemCatType === 'item-request'){
                this.$refs.updateForm.dropItemCat(data);
            }else if(this.itemCatType === 'sidebar'){
                this.$refs.itemListSB.dropItemCat(data);
            }else{
                this.itemResource.itemCategoryId = data.id;
                this.itemResource.itemCategoryName = data.name;
            }
        },
        onSubmitItemResource(){
            var data = {
                id: this.selectedItemResource.id,
                apiId: this.selectedItemResource.apiId,
                deliveryUnitBudgetItemId: this.selectedItemResource.deliveryUnitBudgetItemId,
                itemName: this.itemResource.itemName,
                description: this.itemResource.description,
                unitId: this.itemResource.unitId,
                type: this.selectedItemResource.type,
                subType: this.selectedItemResource.subType,
                isProcurable: this.selectedItemResource.isProcurable,
                isMixed: this.selectedItemResource.isMixed,
                cseId: this.selectedItemResource.cseId,
                itemCategoryId: this.itemResource.itemCategoryId,
                unitCost: this.selectedItemResource.unitCost,
                image: this.selectedItemResource.image,
                thumbnail: this.selectedItemResource.thumbnail,
                mixParentId: this.selectedItemResource.mixParentId,
            }
            this.$store
                .dispatch("apiresource/UpdatePPMPItem", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, 'warning');
                    }
                    this.selectedItemResource.itemName = this.itemResource.itemName;
                    this.selectedItemResource.description = this.itemResource.description;
                    this.selectedItemResource.unitId = this.itemResource.unitId;
                    this.selectedItemResource.unit.shortName = this.itemResource.unitName;
                    if(this.itemResource.itemCategoryId != this.selectedItemResource.itemCategoryId){
                        let index = this.selectedParent.data.indexOf(this.selectedItemResource);
                        this.selectedParent.data.splice(index, 1);
                        if(this.selectedParent.data.length == 0){
                            let parentIndex = this.selectedGrandparent.groupItems.indexOf(this.selectedParent);
                            this.selectedGrandparent.groupItems.splice(parentIndex, 1);
                        }
                        let dashboardData = JSON.parse(localStorage.getItem("dashboardData"));
                        dashboardData.needTechnicalReview = dashboardData.needTechnicalReview - 1;
                        localStorage.setItem("dashboardData", JSON.stringify(dashboardData));
                        this.attachedDUNotifications();
                    }
                    this.$bvModal.hide('update-item-modal');
                    this.showToast('Successfully updated', 'success');
                })
                .catch((err) => {
                    this.showToast('Something went wrong!', 'error');
                });
        },
        getUnit(type) {
            this.unitType = type;
            this.$refs.unit.getData();
            this.$bvModal.show("unit-modal");
        },
        dropUnit(data) {
            if(this.unitType === 'item-request'){
                this.$refs.updateForm.dropUnit(data);
            }else if(this.unitType === 'sidebar'){
                this.$refs.itemListSB.dropUnit(data);
            }else{
                this.itemResource.unitName = data.shortName;
                this.itemResource.unitId = data.id;
            }
        },
        returnItemRequest(item){
            this.$refs.returnModal.returnData(item);
            this.itemRow = cloneDeep(item)
            this.$bvModal.show('return-modal');
        },
        async returnItemSubmission(modalData) {
            let remarks = [];
            let data = cloneDeep(modalData);
            if(this.itemRow.returnRemarks){
                remarks = JSON.parse(this.itemRow.returnRemarks);
            }
            remarks.push({
                remarks: data.remarks,
                date: this.getDate(new Date()),
                user: this.myProfile ? `${this.myProfile.completeName}(${this.myProfile.deliveryUnit})` : "Unknown",
            });
            let newData = { id: data.id, remarks: JSON.stringify(remarks)}
            await this.$store
                .dispatch("itemrequest/ReturnItemRequest", newData)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    let parentIndex = this.pendingRequestItems.findIndex(x => x.deliveryUnitId == this.itemRow.deliveryUnitId);
                    let index = this.pendingRequestItems[parentIndex].items.findIndex(x => x.id == this.itemRow.id);
                    this.pendingRequestItems[parentIndex].items.splice(index, 1);
                    if(this.pendingRequestItems[parentIndex].items.length == 0){
                        this.pendingRequestItems.splice(parentIndex, 1);
                    }
                    this.$bvModal.hide('return-modal');
                    this.showToast("Successfully returned", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        approveItemRequest(item){
            Swal.fire({
                title: "Are you sure?",
                text: "You want to approve this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, approve it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("itemrequest/ApproveItemRequest", item.id)
                        .then((res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let parentIndex = this.pendingRequestItems.findIndex(x => x.deliveryUnitId == item.deliveryUnitId);
                            let index = this.pendingRequestItems[parentIndex].items.findIndex(x => x.id == item.id);
                            this.pendingRequestItems[parentIndex].items.splice(index, 1);
                            if(this.pendingRequestItems[parentIndex].items.length == 0){
                                this.pendingRequestItems.splice(parentIndex, 1);
                            }
                            this.showToast("Successfully approved", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        updateItemRequest(modalData){
            var data = cloneDeep(modalData);
            data.unitCost = this.getExactAmt(modalData.unitCost);
            data.departmentId = modalData.departmentId || 0;
            this.$store
                .dispatch("itemrequest/UpdateItemRequest", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(
                            res.data.errorMessage,
                            "error"
                        );
                    }
                    let parentIndex = this.pendingRequestItems.findIndex(x => x.deliveryUnitId == data.deliveryUnitId);
                    let index = this.pendingRequestItems[parentIndex].items.findIndex(x => x.id == data.id);
                    this.pendingRequestItems[parentIndex].items.splice(index, 1, data);
                    this.showToast("Successfully updated!", "success");
                    this.$bvModal.hide('item-update-modal');
                })
                .catch((err) => {
                    this.showToast(
                        "Something went wrong! - updating item",
                        "error"
                    );
                });
            this.submitted = false;
        },
        updateRequest(item){
            this.$refs.updateForm.putData(item);
            this.$bvModal.show('item-update-modal');
        },
        viewLog(item){
            var logs = JSON.parse(item.returnRemarks);
            logs.map(item => {
                item.dateWTime = this.formatDateWithTime(
                    new Date(item.date)
                );
                item.splitted = item.dateWTime.split(" at ");
            })
            this.$refs.itemLogs.getData(logs);
            this.$bvModal.show('item-request-logs-modal');
        },
    },
};
</script>
<template>
    <Layout @changeCycle="changeParameters($event, $store.state.data.selectedCampus.id)" @changeCampus="changeParameters($store.state.data.cycle, $event.id)">
        <PageHeader :title="title" :items="items" />
        <b-modal
            id="return-modal"
            title="Return Remarks"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form @submit.prevent="returnSubmit" class="needs-validation">
                <b-row>
                    <b-col>
                        <div class="mb-3">
                            <label for="description">Remarks </label>
                            <textarea
                                id="description"
                                rows="3"
                                v-model="form.remarks"
                                placeholder="Enter Remarks..."
                                class="form-control"
                                :class="{
                                    'is-invalid':
                                        submitted && $v.form.remarks.$error,
                                }"
                            ></textarea>
                            <div
                                v-if="submitted && $v.form.remarks.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.form.remarks.required"
                                    >This value is required.</span
                                >
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Return Resource Item
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="hideModal"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <!-- <b-modal
            id="update-item-modal"
            title="Update Item Resource"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form @submit.prevent="onSubmitItemResource">
                <div v-if="itemResource">
                    <div class="mb-3">
                        <label for="name">Item Name </label>
                        <textarea
                            id="name"
                            rows="3"
                            v-model="itemResource.itemName"
                            placeholder="Enter Name..."
                            class="form-control"
                            :class="{
                                'is-invalid':
                                    submitted && $v.itemResource.itemName.$error,
                            }"
                        ></textarea>
                        <div
                            v-if="submitted && $v.itemResource.itemName.$error"
                            class="invalid-feedback"
                        >
                            <span v-if="!$v.itemResource.itemName.required"
                                >This value is required.</span
                            >
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="description">Item Description </label>
                        <textarea
                            id="description"
                            rows="3"
                            v-model="itemResource.description"
                            placeholder="Enter Remarks..."
                            class="form-control"
                            :class="{
                                'is-invalid':
                                    submitted && $v.itemResource.description.$error,
                            }"
                        ></textarea>
                        <div
                            v-if="submitted && $v.itemResource.description.$error"
                            class="invalid-feedback"
                        >
                            <span v-if="!$v.itemResource.description.required"
                                >This value is required.</span
                            >
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="description">Item Category </label>
                        <b-input-group>
                            <template #append>
                                <b-button
                                    @click="
                                        getItemCategory
                                    "
                                    variant="outline-info"
                                    ><i
                                        class="
                                            mdi
                                            mdi-clipboard-text-search-outline
                                        "
                                    ></i
                                ></b-button>
                            </template>
                            <input
                                autocomplete="off"
                                type="text"
                                disabled
                                placeholder="Search Item Category..."
                                class="
                                    form-control text-warning
                                "
                                :class="{
                                    'is-invalid':
                                        $v.itemResource
                                            .itemCategoryId
                                            .$error,
                                }"
                                v-model="
                                    itemResource.itemCategoryName
                                "
                            />
                        </b-input-group>
                        <div
                            v-if="
                                $v.itemResource
                                    .itemCategoryId
                                    .$error
                            "
                            class="
                                invalid-feedback
                            "
                        >
                            <span
                                v-if="
                                    !$v.itemResource
                                        .itemCategoryId
                                        .required
                                "
                                >This value is
                                required.</span
                            >
                        </div>
                    </div>
                    <div class="mb-3">
                        <label
                            for="unitId"
                            class="mb-0"
                            >Unit
                        </label>
                        <b-input-group>
                            <template #append>
                                <b-button
                                    @click="
                                        getUnit('review')
                                    "
                                    variant="outline-info"
                                    ><i
                                        class="
                                            mdi
                                            mdi-clipboard-text-search-outline
                                        "
                                    ></i
                                ></b-button>
                            </template>
                            <input
                                autocomplete="off"
                                type="text"
                                disabled
                                placeholder="Search Unit..."
                                class="
                                    form-control text-warning
                                "
                                :class="{
                                    'is-invalid':
                                        $v.itemResource
                                            .unitId
                                            .$error,
                                }"
                                v-model="itemResource.unitName"
                            />
                        </b-input-group>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Update Resource Item
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('update-item-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal> -->
        <b-tabs content-class="pt-3 pb-3 text-muted">
            <b-tab active>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="far fa-list"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Item Request(s) <span class="text-yellow">({{pendingReqTotal}})</span></span>
                </template>
                <RequestItemCard 
                    :items="pendingRequestItems" 
                    :loading="pendingItemBusy" 
                    :withActions="true" 
                    @returnItem="returnItemRequest"
                    @approveItem="approveItemRequest"
                    @updateItem="updateRequest"
                    @viewLog="viewLog"
                />
            </b-tab>
            <b-tab @click="getItemRequests('approved')">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="far fa-user"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Reviewed <span class="text-yellow">({{approvedReqTotal}})</span></span>
                </template>
                <RequestItemCard 
                    :items="approvedRequestItems" 
                    :loading="pendingItemBusy" 
                    :withActions="false" 
                />
            </b-tab>
        </b-tabs>
        <print-options ref="printOpt"></print-options>
        <item-category @dropData="dropItemCat($event)"></item-category>
        <unit ref="unit" @dropData="dropUnit($event)"></unit>
        <ReturnModal ref="returnModal" @returnItem="returnItemSubmission" />
        <UpdateItemRequest 
            ref="updateForm" 
            @updateItemRequest="updateItemRequest" 
            @getUnit="getUnit('item-request')"
            @getItemCategory="getItemCategory('item-request')"
        />
        <item-logs ref="itemLogs"></item-logs>
        <ItemListSidebar 
            ref="itemListSB"
            :tableData="tableData"
            :tableBusy="itemBusy"
            :itemCats="itemCats"
            @get-item-category="getItemCategory('sidebar')"
            @get-unit="getUnit('sidebar')"
        />
    </Layout>
</template>